import { environment } from '../../environments/environment';

export class AppSetting {
  public static readonly exportFileOptions = [
    { id: 2, name: 'csv', extension: '.CSV' },
    { id: 3, name: 'pdf', extension: '.PDF' },
  ];

  public static readonly paginationItemPerPage = [{ value: 10 }, { value: 25 }, { value: 50 }];
  static launchDarklyProjectName: 'LD_AllyPortal';
  static refreshTokenRenewTime = 840000; // 14 min
  public static readonly defaultCountry = 1;
  public static readonly csvExportCountLimit = 12000;
  public static readonly pdfExportCountLimit = 2000;
  public static readonly exportDaysLimitForScenarioOne = 365;

  static privacyPolicyUrl = 'https://anddone.com/privacy/';
  static termsOfUseUrl = 'https://anddone.com/terms/';
  public static readonly pwd = environment.dummy_pswd; // this is used to avoid veracode static scan issue for hardcoded password in code. This is not used anywhere in the code and can be removed in future when we have better solution to avoid veracode issue for hardcoded password in code.
  public static readonly replacePathFrom = 'cid:headerLogo';
  public static readonly replacePathWith = '../../assets/images/AllyLogoDark.svg';
  public static readonly replacePathFromPlainText = '[[EmailSetting.ImageUrl]]';
}
